import { useState, useEffect } from 'react'
import api, { IBookingImport, IPageInfo } from '@api'
import { GridTableStatusEnum, IGridTableCell } from '@ui'

export default function useBookingImportHistory() {
  const [imports, setImports] = useState<IGridTableCell<IBookingImport>[]>([])
  const [status, setStatus] = useState<GridTableStatusEnum>(GridTableStatusEnum.LOADING)
  const [pageInfo, setPageInfo] = useState<IPageInfo | null>(null)

  const load = () => {
    api.booking.import.list().then(({ imports, pageInfo }) => {
      setImports(imports.map((i) => ({ data: i })))
      setPageInfo(pageInfo)
      setStatus(GridTableStatusEnum.IDLE)
    })
  }

  const onNextPage = () => {
    setStatus(GridTableStatusEnum.LOADING)
    api.booking.import
      .list(pageInfo?.endCursor)
      .then(({ imports: newImports, pageInfo: newPageInfo }) => {
        const newCells = newImports.map((i) => ({ data: i }))
        setImports([...imports, ...newCells])
        setPageInfo(newPageInfo)
        setStatus(GridTableStatusEnum.IDLE)
      })
  }

  useEffect(load, [])

  return { imports, status, reload: load, pageInfo, onNextPage }
}
